import { dialog } from "../../../../nq-component";
import BaseListPresenter from "../../../../base/BaseListPresenter";
import DialogModal from "../../../../components/Dialog";
import { auditLogUseCase } from "../../../../usecases/logs";
import {
  buildHeaderKeyMap,
  extractDRHeader,
  extractItemName,
  extractSku,
  findHeaderRow,
  makeUUID,
  normalizeHeaderText,
  toMoneyString,
  toNumber,
} from "./utils/itemParsing";
import PreviewImportModal from "./components/PreviewImportModal";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import {
  format,
  startOfDay,
  addHours,
  addMinutes,
  addDays,
  parseISO,
} from "date-fns";

class ReceivableItemPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
  ) {
    super(view, findObjectUseCase, deleteObjectUseCase);
    this.findObjectUseCase = findObjectUseCase;
    this.countObjectUseCase = countObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertUseCase = upsertUseCase;
  }

  init() {
    // const user = this.view.getCurrentUser();
    // const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    // const storeId = user?.storeAnalytic?.[0]?.id;
    // this.where = hasAdminRole ? {} : { "storeId.id": { $eq: storeId } };
    const user = this.view.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    this.where = hasAdminRole ? {} : { "storeId.id": { $eq: storeId } };
    // this.where = {};
    this.limit = 20;
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    this.reset();
    await this.countObjects();
    await this.findObjects();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },
      include: this.include,
      count: true,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    // const keys = this.keys || this.view.getKeys() || [];
    // if (keys.length > 0) {
    //   query.keys = keys;
    // }
    return query;
  }

  async countObjects() {
    try {
      this.showProgress();
      const collection = this.view.getCollectionName();
      const query = this.createQuery();
      const { count } = await this.countObjectUseCase.execute(collection, {
        where: query.where,
      });
      this.count = count;
      this.view.setCount(this.count);
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(this.objects);
      this.view.setCount(this.count);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onClickAdd() {
    this.view.navigateTo("/collection/receivable_items/form/manual");
  }

  onClickEdit(index) {
    const object = this.objects[index];
    this.view.navigateTo("/collection/receivable_items/form/name/" + object.id);
  }

  onClickView(index) {
    const object = this.objects[index];
    this.view.navigateTo(
      "/collection/receivable_items/form/" + object.id + "/view",
    );
  }

  async onClickDelete(index) {
    dialog.close();
    const object = this.objects[index];
    const collection = this.view.getCollectionName();

    await this.deleteObjectUseCase.execute(collection, object.id);
    const indexes = this.objects.indexOf(object.id);

    this.objects.splice(index, 1);
    this.view.setObjects([...this.objects]);
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Deleted Successfully"
          message=""
          isCancelButton={false}
          onSubmit={() => {
            dialog.close();
          }}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  async submit(index, status) {
    dialog.close();
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const object = this.objects[index];
    const now = new Date();
    const currentTimestamp = now.toISOString();

    console.log("o", object);

    if (object.id) {
      object.updatedBy = { id: user.id };
    } else {
      this.change.acl = this.view.getAcl();
      delete this.change.updatedBy;
      this.change.createdBy = { id: user.id };
    }

    object.status = status;
    console.log("save", object);

    try {
      const response = await this.upsertUseCase.execute(collection, object);

      await auditLogUseCase().create({
        user: { id: user.id },
        logDate: currentTimestamp,
        message: `Adding Item ${response?.["dr#"]} with status ${status} (s)`,
        collection,
        objectId: response.id,
        payload: {
          request: this.change,
          response: response,
        },
        store: { id: user.storeAnalytic?.[0]?.id },
      });

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              // this.view.navigateBack();
              this.view.reload();
              dialog.close();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });

      this.change = {};
    } catch (error) {
      throw error;
    }
  }

  confirmImport() {
    dialog.close();
    const items = this.view.state.csvPreview || [];
    if (!items.length) return;

    const {
      drNo = "",
      drType = "",
      remarks = "",
    } = this.view.state.drHeader || {};

    try {
      this.showProgress?.();

      const payload = {
        ["dr#"]: drNo,
        drType: drType || "",
        remarks: remarks || "",
        raw_materials: items.map((it, idx) => ({
          id: makeUUID(),
          sku: extractSku(it.productDescription) || String(idx + 1),
          itemName: extractItemName(it.productDescription),
          cost: toMoneyString(it.price),
          quantity: String(it.quantity ?? 0),
          received: String(it.quantity ?? 0),
          remaining: it.quantity - it.quantity,
          reference: it.referenceNo || "",
          warehouse: it.warehouse || "",
          discount: toMoneyString(it.discount),
          sync: "Not Add",
        })),
      };

      sessionStorage.setItem(
        "receivable_items_import",
        JSON.stringify(payload),
      );

      dialog.close?.();
      this.view.navigateTo("/collection/receivable_items/form/import", {
        state: { payload },
      });
    } catch (err) {
      throw err;
    } finally {
      this.hideProgress?.();
    }
  }

  handleParsedObjects(rawRows, drHeader) {
    dialog.close();
    if (!rawRows?.length) {
      dialog.fire({
        html: <div className="p-3">No rows parsed.</div>,
        footer: false,
      });
      return;
    }

    const fileHeaders = Object.keys(rawRows[0] || {});
    const headerKeyMap = buildHeaderKeyMap
      ? buildHeaderKeyMap(fileHeaders)
      : (() => {
          const alias = {
            "reference no#": "referenceNo",
            "reference no": "referenceNo",
            "product description": "productDescription",
            warehouse: "warehouse",
            quantity: "quantity",
            unit: "unit",
            price: "price",
            discount: "discount",
            "net price": "netPrice",
            amount: "amount",
          };
          const map = {};
          for (const h of fileHeaders) {
            const norm = normalizeHeaderText(h);
            map[h] = alias[norm];
          }
          return map;
        })();

    const mapRow = (rowObj) => {
      const out = {
        referenceNo: "",
        productDescription: "",
        warehouse: "",
        quantity: 0,
        unit: "",
        price: 0,
        discount: 0,
        netPrice: 0,
        amount: 0,
      };
      for (const [fileHeader, value] of Object.entries(rowObj)) {
        const field = headerKeyMap[fileHeader];
        if (!field) continue;
        switch (field) {
          case "quantity":
          case "price":
          case "discount":
          case "netPrice":
          case "amount":
            out[field] = toNumber(value);
            break;
          default:
            out[field] = String(value ?? "").trim();
        }
      }
      return out;
    };

    const descHeader = fileHeaders.find(
      (h) => normalizeHeaderText(h) === "product description",
    );
    const items = rawRows
      .filter((r) => String(r[descHeader] ?? "").trim() !== "")
      .map(mapRow);

    if (!items.length) {
      dialog.fire({
        html: <div className="p-3">No valid item rows found.</div>,
        footer: false,
      });
      return;
    }

    this.view.setState({ csvPreview: items, drHeader });

    dialog.fire({
      html: (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 9999,
            maxWidth: "95vw",
            maxHeight: "95vh",
            overflow: "auto",
          }}
        >
          <PreviewImportModal
            items={items}
            uploadFilename={this.view.state.uploadFilename}
            drHeader={drHeader}
            onCancel={() => dialog.close()}
            onConfirm={this.confirmImport.bind(this)}
          />
        </div>
      ),
      footer: false,
      width: "100vw",
      padding: 0,
      showClass: {
        popup: "animate__animated animate__fadeIn animate__faster",
      },
      backdrop: true,
      customClass: {
        popup: "custom-wide-modal-popup",
      },
    });
  }

  onFileSelected(e) {
    const file = e.target.files?.[0];
    if (!file) return;

    this.view.setState({ uploadFilename: file.name });

    const ext = file.name.toLowerCase().split(".").pop();
    if (ext === "csv") {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (res) => this.handleParsedObjects(res.data),
      });
      return;
    }

    // xlsx / xls
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const wb = XLSX.read(data, { type: "array" });
      const ws = wb.Sheets[wb.SheetNames[0]];

      // AOA with empty cells preserved
      const aoa = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });

      // Get DR header block from the top
      const drHeader = extractDRHeader(aoa);

      // Find the table header row
      const headerRowIndex = findHeaderRow(aoa); // you already have this
      const sliced = aoa.slice(headerRowIndex);
      const [headers, ...rows] = sliced;

      // Convert table rows to objects with exact file headers
      const rawObjects = rows.map((r) =>
        headers.reduce((acc, h, i) => {
          acc[String(h ?? "").trim()] = r[i];
          return acc;
        }, {}),
      );

      this.handleParsedObjects(rawObjects, drHeader); // <-- pass header
    };
    reader.readAsArrayBuffer(file);
  }

  onChangeDate(where) {
    const { created } = where;

    if (!created || !created.$gte || !created.$lte) {
      this.filterDate = {};
      this.reset();
      this.getObjects();
      return;
    }

    const startDate = addHours(startOfDay(parseISO(created.$gte)), 5);
    const endDate = addMinutes(
      addHours(addDays(startOfDay(parseISO(created.$lte)), 0), 4),
      59,
    );

    this.filterDate = {
      created: {
        $gte: startDate,
        $lte: endDate,
      },
    };

    this.getObjects();
  }
}

export default ReceivableItemPresenter;
